// 各前台頁面共用的 Vue 基底（data / watch / methods）
// 從 resources/src/js/home/*.js 抽出，各頁皆相同的部分集中於此，便於維護。
import { createApp } from "vue/dist/vue.esm-browser.prod.js";
import { subnav_show, subnav_hide, subnav_toggle, m_menu_open } from "@/js/share/components/_header";
import { fastlink_toggle } from "@/js/share/components/_fastlink.js";
import { tracker_handler } from "@/js/share/components/_tracker.js";
import { prevent_rightclick } from "@/js/share/components/_prevent_rightclick.js";

export { createApp };

// 共用的 data 欄位；於各頁 data() 中以 { ...baseData(), ...頁面自有欄位 } 併入
export const baseData = () => ({
    menu_open: false,
    fastlink_show: true,
});

// 共用的 watch；於各頁 watch 中以 { ...baseWatch(this), ...頁面自有 watch } 併入
export const baseWatch = (vm) => ({
    menu_open: m_menu_open(vm),
});

// 共用的 methods；於各頁 methods 中以 { ...baseMethods, ...頁面自有 methods } 併入
export const baseMethods = {
    subnav_show,
    subnav_hide,
    subnav_toggle,
    fastlink_toggle,
    tracker_handler,
    prevent_rightclick,
};
